import { SequenceHelper } from '@/api/commonModel';
import { getIn18Text } from '@/api/utils';
export const mailTable = {
    data: {
        dbName: 'mail_new',
        tableName: 'mail_data',
    },
    content: {
        dbName: 'mail_new',
        tableName: 'mail_content',
    },
    attachment: {
        dbName: 'mail_new',
        tableName: 'mail_attachment',
    },
    status: {
        dbName: 'mail_new',
        tableName: 'mail_status',
    },
    attr: {
        dbName: 'mail_new',
        tableName: 'mail_attr',
    },
    statistic: {
        dbName: 'mail_new',
        tableName: 'mail_statistic',
    },
    tpMail: {
        dbName: 'mail_new',
        tableName: 'third_party_mail',
    },
    tpMailContent: {
        dbName: 'mail_new',
        tableName: 'third_party_mail_content',
    },
};
export const mailBoxTable = {
    dbName: 'mail_new',
    tableName: 'mail_box',
};
export const mailOperationTable = {
    dbName: 'mail_new',
    tableName: 'operation',
};
export const mailComposeDataTable = {
    dbName: 'mail_new',
    tableName: 'composed_mail',
};
export const mailUnfinishedMailTable = {
    dbName: 'mail_new',
    tableName: 'unfinished_mail',
};
export const MailRecpErrMap = {
    FA_MTA_MULTI_ERROR: '该邮箱将您设为黑名单',
    FA_MTA_RCPT_ERROR: '该邮箱不存在',
    FA_MTA_USER_BLACK_LIST: '该邮箱将您设为黑名单',
    FA_MTA_MAILLIST_DENIED: '您无权限使用此邮件列表，请联系管理员',
    FA_WRONG_RECEIPT: '收件人格式错误',
    FA_MTA_ACCESS_DENIED: '您无该邮箱的发信权限，如有需要，请联系管理员',
};
export var EntSignatureDisplayType;
(function (EntSignatureDisplayType) {
    EntSignatureDisplayType[EntSignatureDisplayType["ReadAndWrite"] = 0] = "ReadAndWrite";
    EntSignatureDisplayType[EntSignatureDisplayType["ReadOnly"] = 1] = "ReadOnly";
})(EntSignatureDisplayType || (EntSignatureDisplayType = {}));
export class MethodMap {
    constructor() {
        this.listFolder = 'mbox:getAllFolders';
        this.createUserFolder = 'mbox:createUserFolders';
        this.updateUserFolder = 'mbox:updateFolders';
        this.deleteUserFolder = 'mbox:deleteFolders';
        this.updateMessageInfos = 'mbox:updateMessageInfos';
        this.updateFolderPosition = 'mbox:setFolderPosition';
        this.listItem = 'mbox:listMessages';
        this.listContent = 'mbox:readMessage';
        this.decryptedContent = 'mbox:decryptMessage';
        this.sendMDN = 'mbox:sendMDN';
        this.postMail = 'mbox:compose';
        this.cancelDeliver = 'mbox:cancelDeliver';
        this.immediateDeliver = 'mbox:immediateDeliver';
        this.checkPostMail = 'user:listDeliveryHistory';
        this.updateMail = 'mbox:updateMessageInfos';
        this.deleteMail = 'mbox:deleteMessages';
        this.searchMail = 'mbox:searchMessages';
        this.searchMailInfo = 'mbox:getMessageSummaryInfos';
        this.getMailPart = 'mbox:getMessageData';
        this.getDecryptedMailPart = 'mbox:decryptMessagePart';
        this.replyMail = 'mbox:replyMessage';
        this.forwardMail = 'mbox:forwardMessages';
        this.uploadPrepare = 'upload:prepare';
        this.upload = 'upload:directData';
        this.uploadLegacy = 'mbox:uploadAttach';
        this.loadTemp = 'mbox:getComposeInfo';
        this.downloadTmpAttachment = 'mbox:getComposeData';
        this.cancelCompose = 'mbox:cancelComposes';
        this.markAllMail = 'mbox:markSeen';
        this.markPreferred = 'mbox:markPreferred';
        this.getAttr = 'user:getAttrs';
        this.setAttr = 'user:setAttrs';
        this.updatePOPAccounts = 'user:updatePOPAccounts';
        this.emptyFolder = 'mbox:emptyFolder';
        this.editDraft = 'mbox:restoreDraft';
        this.editMail = 'mbox:editMessage';
        this.statMailCount = 'mbox:statMessages';
        this.attachmentPreview = 'preview:convert';
        this.getContentByIds = 'mbox:getMessageInfos';
        this.getFolderStat = 'mbox:getFolderStats';
        this.withdrawSending = 'mbox:recallMessage';
        this.threadMail = 'mbox:listThreads';
        this.threadMailDetailV2 = 'ntes:mbox:getThreadMessagesInfos';
        this.threadMailDetail = 'mbox:getThreadMessageInfos';
        this.updateMailThread = 'ntes:mbox:updateThreadInfos';
        this.getSignature = 'user:getSignatures';
        this.createSignature = 'user:createSignatures';
        this.updateSignature = 'user:updateSignatures';
        this.deleteSignature = 'user:deleteSignatures';
        this.getMailClassifyRule = 'user:getMailRules';
        this.addMailClassifyRule = 'user:addMailRules';
        this.editMailClassifyRule = 'user:updateMailRules';
        this.sortMailClassifyRule = 'user:adjustMailRuleOrder';
        this.deleteMailClassifyRule = 'user:removeMailRules';
        this.effectHistoryMail = 'mbox:updateMessageInfos';
        this.aliasAccount = 'user:getAliasWithSeed';
        this.getTaglist = 'mbox:listTags';
        this.manageTag = 'mbox:manageTags';
        this.updateMessageTags = 'mbox:updateMessageTags';
        this.threadMailList = 'mbox:listConvs';
        this.threadMailInfoDetail = 'mbox:getConvInfos';
        this.updateThreadInfo = 'mbox:updateConvInfos';
        this.updateThreadTags = 'mbox:updateConvTags';
        this.listAttachments = 'mbox:listAttachments';
        this.uploadMail = 'mbox:uploadMail';
        this.contactStats = 'contact:stats';
        this.sequential = 'global:sequential';
        this.unlockSecurityLock = 'user:authenticate2';
    }
}
export const watchConf = {
    attachmentPreview: { updateStatus: false, cache: false },
    cancelCompose: { updateStatus: false, cache: false },
    checkPostMail: { updateStatus: false, cache: false },
    deleteMail: { updateStatus: true, cache: false },
    downloadTmpAttachment: { updateStatus: false, cache: false },
    editDraft: { updateStatus: false, cache: false },
    editMail: { updateStatus: false, cache: false },
    emptyFolder: { updateStatus: true, cache: false },
    getAttr: { updateStatus: false, cache: true },
    getContentByIds: { updateStatus: false, cache: true },
    getFolderStat: { updateStatus: false, cache: false },
    listContent: { updateStatus: false, cache: true, immutable: true },
    listFolder: { updateStatus: false, cache: true },
    contactStats: { updateStatus: false, cache: true },
    createUserFolder: { updateStatus: false, cache: true },
    updateUserFolder: { updateStatus: false, cache: true },
    deleteUserFolder: { updateStatus: false, cache: true },
    updateFolderPosition: { updateStatus: false, cache: true },
    listItem: { updateStatus: false, cache: true },
    getMailPart: { updateStatus: false, cache: true, immutable: true },
    loadTemp: { updateStatus: false, cache: false },
    markAllMail: { updateStatus: true, cache: false },
    postMail: { updateStatus: true, cache: false },
    cancelDeliver: { updateStatus: true, cache: false },
    immediateDeliver: { updateStatus: true, cache: false },
    replyMail: { updateStatus: false, cache: false, immutable: false },
    forwardMail: { updateStatus: false, cache: false, immutable: false },
    searchMail: { updateStatus: false, cache: true },
    searchMailInfo: { updateStatus: false, cache: true, immutable: true },
    statMailCount: { updateStatus: false, cache: false },
    updateMail: { updateStatus: true, cache: false },
    updateMailThread: { updateStatus: true, cache: false },
    upload: { updateStatus: false, cache: false },
    uploadLegacy: { updateStatus: false, cache: false },
    uploadPrepare: { updateStatus: false, cache: false },
    withdrawSending: { updateStatus: false, cache: false },
    getSignature: { updateStatus: false, cache: true },
    createSignature: { updateStatus: false, cache: false },
    updateSignature: { updateStatus: false, cache: false },
    deleteSignature: { updateStatus: false, cache: false },
    threadMailDetailV2: { updateStatus: false, cache: true },
    threadMailDetail: { updateStatus: false, cache: true },
    threadMail: { updateStatus: false, cache: true },
    aliasAccount: { updateStatus: false, cache: true },
    getTaglist: { updateStatus: false, cache: true },
    manageTag: { updateStatus: false, cache: true },
    updateMessageTags: { updateStatus: true, cache: false },
    listAttachments: { updateStatus: false, cache: true },
};
export class MailEntryContactMap {
    constructor() {
        this.total = 0;
        this.data = {};
    }
}
export const mailBoxOfAllRes = {
    id: -33,
    sort: -1,
    fold: 1,
    name: getIn18Text('QUANBUJIEGUO'),
};
export const mailBoxOfDefault = {
    id: 1,
    sort: 0,
    fold: 1,
};
export const mailBoxOfSent = {
    id: 3,
    sort: 10,
    fold: 1,
    name: getIn18Text('FAJIANXIANG'),
};
export const mailBoxOfRdFlag = {
    id: -1,
    sort: 20,
    fold: 1,
    name: getIn18Text('HONGQIYOUJIAN'),
};
export const mailBoxOfUnread = {
    id: -4,
    sort: 1,
    fold: 1,
    name: getIn18Text('WEIDUYOUJIAN'),
};
export const mailBoxOfEdmReply = {
    id: 21,
    sort: 0.5,
    fold: 1,
    name: getIn18Text('YINGXIAOQIANKHF'),
};
export const mailBoxOfEdmOtherReply = {
    id: 22,
    sort: 0.6,
    fold: 1,
    name: getIn18Text('YINGXIAOQITHF'),
};
export const mailBoxOfCustomerUnFollow = {
    id: -17,
    sort: 11,
    fold: 1,
    name: getIn18Text('YOUDANGDAIGJ'),
};
export const mailBoxOfUnFollow = {
    id: -18,
    sort: 12,
    fold: 1,
    name: getIn18Text('WUDANGDAIGJ'),
};
export const mailBoxOfTask = {
    id: -9,
    sort: 30,
    fold: 1,
    name: getIn18Text('RENWUYOUJIAN'),
};
export const mailBoxOfDefer = {
    id: -3,
    sort: 35,
    fold: 1,
    name: getIn18Text('SHAOHOUCHULI'),
};
export const mailBoxOfStar = {
    id: -5,
    sort: 3,
    fold: 1,
    name: getIn18Text('XINGBIAOLIANXIREN'),
};
export const mailBoxOfDraft = {
    id: 2,
    sort: 40,
    fold: 1,
};
export const mailBoxOfWaitingIssue = {
    id: 17,
    sort: 50,
    fold: 1,
    name: getIn18Text('WEISHENHE'),
};
export const mailBoxOfReadyIssue = {
    id: 19,
    sort: 60,
    fold: 1,
    name: getIn18Text('YISHENHE'),
};
export const mailBoxOfSpam = {
    id: 5,
    sort: 80,
    fold: 1,
    hide: false,
};
export const mailBoxOfAd = {
    id: 7,
    sort: 70,
    fold: 1,
    name: getIn18Text('GUANGGAOYOUJIAN'),
};
export const mailBoxOfVirus = {
    id: 6,
    sort: 90,
    fold: 1,
    hide: true,
};
export const mailBoxOfDeleted = {
    id: 4,
    sort: 100,
    fold: 1,
};
export const mailBoxOfOthers = {
    id: -2,
    sort: 99999,
    fold: 1,
    name: getIn18Text('ZIDINGYIWENJIAN11'),
};
export const mailBoxOfFakeThread = {
    id: -100001,
};
export const mailBoxOfFilterStar = {
    [mailBoxOfSpam.id]: true,
    [mailBoxOfDraft.id]: true,
    [mailBoxOfDeleted.id]: true,
};
export class ActionStore {
    constructor() {
        this.attachmentLock = [];
        this.decryptedMailsCache = new Map();
        this.curMailSequenceGen = new SequenceHelper();
        this.curMailListReqSeq = this.curMailSequenceGen.next();
        this.curMailContentReqSeq = this.curMailSequenceGen.next();
        this.curMailSearchReqSeq = this.curMailSequenceGen.next();
        this.curRealListReqSeq = this.curMailSequenceGen.next();
        this.searchResCache = {};
        this.searchResCache_sd = {};
        this.searchResCacheMoreAccounts = {};
        this.searchWord = {};
        this.searchMidsCache = {};
        this.searchStatCache = {};
        this.mailEntryCache = {};
        this.mailBoxDic = {};
        this.praiseMedals = [];
        this.lastMailBoxUpdateTime = {};
        this.lastUserAttrUpdateTime = -1;
        this.lastSignatureUpdateTime = -1;
        this.writingMailIds = new Set();
        this.paramDispatched = new Set();
        this.paramReceivedSucc = new Set();
        this.mailParamMap = {};
        this.threadMailIdMap = {};
        this.lastSaveTmpTimestamp = 0;
        this.mailBoxConfs = ((param) => {
            const ret = {};
            for (const item of param) {
                ret[item.id] = item;
                if (item === mailBoxOfDeleted) {
                    item.getUnreadNumber = () => ({
                        currentUnread: 0,
                        unread: 0,
                        threadUnread: 0,
                        currentThreadUnread: 0,
                    });
                }
                else if (item === mailBoxOfSent) {
                    const number = this.checkAllFailToSendMails();
                    item.getUnreadNumber = () => ({
                        currentUnread: number,
                        unread: number,
                        threadUnread: number,
                        currentThreadUnread: number,
                    });
                }
                else if (item === mailBoxOfDefer) {
                    item.getUnreadNumber = (mbIt) => {
                        const { deferCount = 0 } = mbIt.entry;
                        return {
                            currentUnread: deferCount,
                            unread: deferCount,
                            threadUnread: deferCount,
                            currentThreadUnread: deferCount,
                        };
                    };
                }
                else if (item === mailBoxOfStar) {
                    item.getUnreadNumber = () => ({
                        currentUnread: 0,
                        unread: 0,
                        threadUnread: 0,
                        currentThreadUnread: 0,
                    });
                }
            }
            for (let i = 8; i < 50; ++i) {
                if (!ret[i] || !ret[i].id) {
                    ret[i] = {
                        id: i,
                        sort: 2 + i,
                        fold: 1,
                    };
                }
            }
            return ret;
        })([
            mailBoxOfAllRes,
            mailBoxOfDefault,
            mailBoxOfSent,
            mailBoxOfRdFlag,
            mailBoxOfUnread,
            mailBoxOfCustomerUnFollow,
            mailBoxOfUnFollow,
            mailBoxOfEdmReply,
            mailBoxOfEdmOtherReply,
            mailBoxOfTask,
            mailBoxOfDeleted,
            mailBoxOfDraft,
            mailBoxOfOthers,
            mailBoxOfSpam,
            mailBoxOfAd,
            mailBoxOfVirus,
            mailBoxOfReadyIssue,
            mailBoxOfWaitingIssue,
            mailBoxOfDefer,
            mailBoxOfStar,
        ]);
        this.searchSeq = new SequenceHelper(1, 1000000);
        this.needSendWriteMail = false;
        this.updateMethodTriggered = false;
        this.methodStatus = {};
        this.attachmentLock = [];
        this.taskMailMap = null;
    }
    searchContentOfEntry(content, search) {
        var _a, _b, _c, _d;
        if (content.entry.title && content.entry.title.indexOf(search) >= 0) {
            return true;
        }
        if (content.entry.content && content.entry.content.content && content.entry.content.content.indexOf(search) >= 0) {
            return true;
        }
        if (content.entry.attachment && content.entry.attachment.length >= 0) {
            const attachModels = content.entry.attachment;
            const found = attachModels.find(it => it.fileName.indexOf(search) >= 0);
            return found !== undefined;
        }
        if (content.sender && (((_b = (_a = content.sender.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal) === null || _b === void 0 ? void 0 : _b.indexOf(search)) >= 0 || ((_d = (_c = content.sender.contact) === null || _c === void 0 ? void 0 : _c.contact.contactName) === null || _d === void 0 ? void 0 : _d.indexOf(search)) >= 0)) {
            return true;
        }
        if (content.receiver && content.receiver.length > 0) {
            const found = content.receiver.find(it => { var _a, _b, _c, _d; return ((_b = (_a = it.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal) === null || _b === void 0 ? void 0 : _b.indexOf(search)) >= 0 || ((_d = (_c = it.contact) === null || _c === void 0 ? void 0 : _c.contact.contactName) === null || _d === void 0 ? void 0 : _d.indexOf(search)) >= 0; });
            return found !== undefined;
        }
        return false;
    }
    checkAllFailToSendMails() {
        const { mailEntryCache } = this;
        let num = 0;
        Object.keys(mailEntryCache).forEach((i) => {
            const cacheElement = mailEntryCache[Number(i)];
            if (cacheElement && cacheElement.entry.sendStatus && cacheElement.cid && cacheElement.id) {
                num += 1;
            }
        });
        return num;
    }
}
ActionStore.dbEnable = true;
ActionStore.dbEnableKey = 'mailDbEnable';
ActionStore.keyMailSyncTime = '-mailSyncTimestamp-';
ActionStore.keyCustomerUnreadSyncTime = '-customerUnreadSyncTimestamp-';
ActionStore.keyMailContentSyncTime = '-mailContentSyncTimestamp-';
ActionStore.minUpdateSpan = 5 * 24 * 3600 * 1000;
ActionStore.maxUpdateSpan = 60 * 24 * 3600 * 1000;
export const methodMap = new MethodMap();
export const tpMailFilterName = 'tpMailFilterName';
export const mailAttrFilterName = 'mailAttrFilterName';
export const mailContentFilterName = 'mailContentFilter';
export const mailContentFolderFilterName = 'mailContentFolderFilter';
export const mailDbCommonQueryFilterName = 'mailDbCommonQueryFilter';
export const localSearchDataFilterName = 'localSearchDataFilterName';
export const mailSearchAttachmentFilterName = 'mailSearchAttachmentFilterName';
export const mailAttachmentOfContentFilterName = 'mailAttachmentOfContentFilterName';
